import React from "react";

const WAbout = () => {
  return (
    <main className="main">
      <section className="serv-comp">
        <div className="common-container">
          <div className="comn-heading">
            <h3>
              About <span>Us</span>{" "}
            </h3>
            <p>
              Nikah-e-Muslim is a faith-based matrimonial and matchmaking platform
              designed to help Muslims find a compatible life partner in a
              respectful, halal, and meaningful way. We focus on creating
              genuine connections that lead to Nikah, guided by Islamic values
              and family involvement.
            </p>

            <p>
              Our platform goes beyond traditional matchmaking by offering
              intelligent profile matching based on personal preferences,
              religious values, lifestyle choices, and family background. Every
              profile is created with care to ensure authenticity, privacy, and
              dignity for all users.
            </p>

            <p>
              Nikah-e-Muslim provides a safe and secure environment where users
              can connect through verified profiles, private chats, and
              controlled communication features. Privacy settings allow you to
              decide who can view your profile details and images.
            </p>

            <p>
              We understand that marriage is not just a personal decision but a
              family journey. That’s why our platform supports family-oriented
              profiles and encourages transparency, honesty, and respectful
              interactions throughout the matchmaking process.
            </p>

            <p>
              With advanced search filters, wishlist options, matches, and
              subscription plans, Nikah-e-Muslim makes the process of finding a
              compatible partner simple, organized, and trustworthy.
            </p>

            <p>
              Our mission is to make halal matchmaking accessible, modern, and
              reliable for Muslims across the globe.
            </p>

            <p>Your journey to Nikah begins with Nikah-e-Muslim.</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default WAbout;
